/**
 * Shared palette used for all fallback facehash avatars across the app.
 * The selected color remains deterministic per seed.
 */
export const FACEHASH_AVATAR_COLORS = ['#00FF5D', '#00F0FF', '#004BFF', '#FC00FF', '#FF0000', '#FF9900'];
